import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type RelevantFactModel = {
  id: string | number
}

export const createNewRelevantFact = () => {
  return new ServicesUseCase('/fatoRelevante', makeAxiosHttpClient())
}

export const fetchListToRelevantFact = (id?: number) => {
  return new ServicesUseCase(
    `/fatoRelevante/getFatoRelevanteAndServico/${id}`,
    makeAxiosHttpClient()
  )
}
export const getByIdRelevantFact = (id: string) => {
  return new ServicesUseCase(
    `/fatoRelevante/getFatoRelevante/${id}`,
    makeAxiosHttpClient()
  )
}

export const updateRelevantFact = () => {
  return new ServicesUseCase(`/fatoRelevante`, makeAxiosHttpClient())
}

export const deleteRelevantFact = ({ id }: RelevantFactModel) => {
  return new ServicesUseCase(
    `/fatoRelevante/deleteFatoRelevante/${id}`,
    makeAxiosHttpClient()
  )
}
